(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ihh-v2-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ihh-origin-carousel')) {
    customElements.define('ihh-origin-carousel', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-enabled')) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.v2-origin-grid');
        this.cards = [...this.querySelectorAll('.v2-origin-card')];
        this.controls = this.querySelector('.v2-origin-controls');
        if (!this.controls || !this.track) return;
        this.previous = this.querySelector('[data-origin-previous]');
        this.next = this.querySelector('[data-origin-next]');
        this.status = this.querySelector('.v2-origin-progress');
        this.previous.addEventListener('click', () => this.move(-1), {signal});
        this.next.addEventListener('click', () => this.move(1), {signal});
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, {passive:true, signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth, behavior:this.behavior()});
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.v2-origin-card');
          if (card && this.contains(card)) {
            const index = this.cards.indexOf(card);
            const first = matchMedia('(max-width: 749px)').matches ? index : Math.floor(index / 2) * 2;
            this.track.scrollTo({left:this.cards[first].offsetLeft, behavior:'instant'});
          }
        }, {signal});
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      behavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
      move(direction) {
        const mobile = matchMedia('(max-width: 749px)').matches;
        const starts = this.cards.filter((_, i) => mobile || i % 2 === 0).map(card => card.offsetLeft);
        const current = this.track.scrollLeft;
        const target = direction > 0 ? starts.find(x => x > current + 4) : starts.findLast(x => x < current - 4);
        this.track.scrollTo({left:target ?? (direction > 0 ? this.track.scrollWidth : 0), behavior:this.behavior()});
      }
      update() {
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({box:card.getBoundingClientRect(), index})).filter(({box}) => box.right > viewport.left + 4 && box.left < viewport.right - 4);
        this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        this.previous.disabled = this.track.scrollLeft <= 8;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 8;
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          const label = (first === last ? first : first + '–' + last) + ' / ' + this.cards.length;
          if (this.status.textContent !== label) this.status.textContent = label;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
